export default "__VITE_ASSET__Cx508cCQ__"